import { Component, ElementRef, Input, OnInit, Renderer2 } from "@angular/core";
import { INavData, navItems } from "./../../../_nav";
import {
  AccountService,
  AuthenticationService,
} from "./../../../main/services";

@Component({
  selector: "app-sidebar-nav",
  template: `
    <nav class="sidebar-nav">
      <ul class="nav">
        <ng-template ngFor let-navitem [ngForOf]="navs">
          <li *ngIf="isDivider(navitem)" class="nav-divider"></li>
          <ng-template [ngIf]="isTitle(navitem) && isShow(navitem)">
            <app-sidebar-nav-title [title]="navitem"></app-sidebar-nav-title>
          </ng-template>
          <ng-template
            [ngIf]="!isDivider(navitem) && !isTitle(navitem) && isShow(navitem)"
          >
            <app-sidebar-nav-item [item]="navitem"></app-sidebar-nav-item>
          </ng-template>
        </ng-template>
        <li (click)="handelLogout()" class="nav-item mt-auto d-none">
          <a class="nav-link nav-link-basic" href="javascript:;">
            <i class="fa fa-sign-out"></i>
            Logout
          </a>
        </li>
      </ul>
    </nav>
    <a
      (click)="handelLogout()"
      class="nav-link nav-link-basic login-custom"
      href="javascript:;"
    >
      Logout
    </a>
  `,
})
export class AppSidebarNavComponent implements OnInit {
  public navs: INavData[] = [];

  isDivider(item: any): boolean {
    return !!item.divider;
  }

  isTitle(item: any): boolean {
    return !!item.title;
  }

  isShow(item: any): boolean {
    return !!item.isShow;
  }

  public handelLogout() {
    this.authenticationService.logout();
    location.reload();
  }

  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly accountService: AccountService,
    private readonly stateService: StateService
  ) {}

  ngOnInit(): void {
    this.getNavItems();
  }

  getNavItems() {
    const navs = navItems;
    this.accountService
      .getPermission()
      .pipe(
        tap(
          (response: {
            error: string;
            result: {
              id: number;
              isShow: boolean;
              level: string;
              page: string;
              parentId: number;
            }[];
            status: boolean;
            statusCode: boolean;
            version: string;
          }) => {
            const result = response.result;
            this.navs = this.mapIsShow(result, navs);
            this.stateService.navItems$.next(this.navs);
          }
        ),
        catchError((error) => {
          console.error(error);
          return of(null);
        })
      )
      .subscribe();
  }

  mapIsShow(response: Array<any>, target: Array<any>) {
    target.forEach((item) => {
      const match = response.find((aItem) => aItem.id === item.id);
      if (match) {
        item.isShow = match.isShow;
      }
      if (item.children && item.children.length > 0) {
        this.mapIsShow(response, item.children);
      }
    });
    return target;
  }
}

import { Router } from "@angular/router";
import { StateService } from "../../../providers/state.service";
import { catchError, of, tap } from "rxjs";

@Component({
  selector: "app-sidebar-nav-item",
  template: `
    <ng-container *ngIf="isShow()">
      <li
        *ngIf="!isDropdown(); else dropdown"
        [ngClass]="hasClass() ? 'nav-item ' + item.class : 'nav-item'"
      >
        <app-sidebar-nav-link [link]="item"></app-sidebar-nav-link>
      </li>
    </ng-container>
    <ng-template #dropdown>
      <li
        [ngClass]="
          hasClass()
            ? 'nav-item nav-dropdown' + item.class
            : 'nav-item nav-dropdown open'
        "
        [class.open]="true"
        appNavDropdown
      >
        <app-sidebar-nav-dropdown [link]="item"></app-sidebar-nav-dropdown>
      </li>
    </ng-template>
  `,
  styleUrls: ["./app-sidebar-nav.component.scss"],
})
export class AppSidebarNavItemComponent {
  @Input() item: any;

  public hasClass(): boolean {
    return !!this.item.class;
  }

  public isDropdown(): boolean {
    return !!this.item.children;
  }

  public isShow(): boolean {
    return !!this.item.isShow;
  }

  public thisUrl() {
    return this.item.url;
  }

  public isActive(): boolean {
    return this.router.isActive(this.thisUrl(), {
      paths: "exact",
      queryParams: "exact",
      fragment: "ignored",
      matrixParams: "ignored",
    });
  }

  constructor(private readonly router: Router) {}
}

@Component({
  selector: "app-sidebar-nav-link",
  template: `
    <a
      *ngIf="!isExternalLink(); else external"
      [ngClass]="
        hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'
      "
      routerLinkActive="active"
      [routerLink]="[link.url]"
    >
      <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
      {{ link.name }}
      <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{
        link.badge.text
      }}</span>
    </a>
    <ng-template #external>
      <a
        [ngClass]="
          hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'
        "
        href="{{ link.url }}"
      >
        <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
        {{ link.name }}
        <span
          *ngIf="isBadge()"
          [ngClass]="'badge badge-' + link.badge.variant"
          >{{ link.badge.text }}</span
        >
      </a>
    </ng-template>
  `,
})
export class AppSidebarNavLinkComponent {
  @Input() link: any;

  public hasVariant(): boolean {
    return !!this.link.variant;
  }

  public isBadge(): boolean {
    return !!this.link.badge;
  }

  public isExternalLink(): boolean {
    return this.link.url.substring(0, 4) === "http";
  }

  public isIcon(): boolean {
    return !!this.link.icon;
  }

  constructor() {}
}

@Component({
  selector: "app-sidebar-nav-dropdown",
  template: `
    <a
      [routerLink]="[link.url]"
      class="nav-link nav-dropdown-toggle"
      appNavDropdownToggle
      routerLinkActive="active"
    >
      <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
      {{ link.name }}
      <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{
        link.badge.text
      }}</span>
    </a>
    <ul class="nav-dropdown-items">
      <ng-template ngFor let-child [ngForOf]="link.children">
        <app-sidebar-nav-item [item]="child"></app-sidebar-nav-item>
      </ng-template>
    </ul>
  `,
})
export class AppSidebarNavDropdownComponent {
  @Input() link: any;

  public isBadge(): boolean {
    return !!this.link.badge;
  }

  public isIcon(): boolean {
    return !!this.link.icon;
  }

  constructor() {}
}

@Component({
  selector: "app-sidebar-nav-title",
  template: "",
})
export class AppSidebarNavTitleComponent implements OnInit {
  @Input() title: any;

  constructor(
    private readonly el: ElementRef,
    private readonly renderer: Renderer2
  ) {}

  ngOnInit() {
    const nativeElement: HTMLElement = this.el.nativeElement;
    const li = this.renderer.createElement("li");
    const name = this.renderer.createText(this.title.name);

    this.renderer.addClass(li, "nav-title");

    if (this.title.class) {
      const classes = this.title.class;
      this.renderer.addClass(li, classes);
    }

    if (this.title.wrapper) {
      const wrapper = this.renderer.createElement(this.title.wrapper.element);

      this.renderer.appendChild(wrapper, name);
      this.renderer.appendChild(li, wrapper);
    } else {
      this.renderer.appendChild(li, name);
    }
    this.renderer.appendChild(nativeElement, li);
  }
}

export const APP_SIDEBAR_NAV = [
  AppSidebarNavComponent,
  AppSidebarNavDropdownComponent,
  AppSidebarNavItemComponent,
  AppSidebarNavLinkComponent,
  AppSidebarNavTitleComponent,
];
